import React, { useState } from 'react';
import Chart from 'react-apexcharts';
import { useSnackbar } from 'notistack';
import { FUNCTION_URL } from '../../Constants/index';
var authProvider = require('../../authProvider');

function AnomalieChart() {
    const anomalie = [];
    const countAnomalie = [];
    const {enqueueSnackbar} = useSnackbar();

    const generateData = async (chartContext, config) => {
        let user_data = authProvider.getData().data;

        let params = {
            chartName: 'AnomalieChart',
            cod_terr_sap_array: localStorage.getItem('cod_terr_sap')
        }
        let anomaliaCounts;

        //even if the sharts are not configured on Dashboard.js this code still runs, so we need this
        //to avoid unnecessary load on the DB
        if (!['administrator', 'dg', 'approvatore'].includes(user_data.role)) {
            anomaliaCounts = await fetch(FUNCTION_URL + '/GetChartData', {
                method: 'POST',
                headers: {
                    'Content-Type': 'text/plain',
                    'x-zumo-auth': localStorage.getItem('auth-token')
                },
                body: JSON.stringify(params)
            })
                .then(response => {
                    if (response.status === 200) {
                        return response.text().then(text => JSON.parse(text));
                    }
                    else {
                        return undefined
                    }
                })
                .catch(error => {
                    console.log(error);
                    return error;
                });
        }


        if (anomaliaCounts && anomaliaCounts.message) {
            setOptions({
                xaxis: {
                    categories: ['']
                }
            });
            setSeries([]);
            showMessage("AnomalieChart: " + anomaliaCounts.message, "error");
        }
        else if (anomaliaCounts && anomaliaCounts.length && anomaliaCounts.length > 0) {
            anomaliaCounts.forEach(s => {
                if (s._id !== undefined) {
                    anomalie.push(s._id);
                    countAnomalie.push(s.count);
                }
            });
            setOptions({
                xaxis: {
                    categories: anomalie
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                }
            });
            setSeries([{
                name: 'Apparati',
                data: countAnomalie
            }]);
        }
        else {
            setOptions({
                xaxis: {
                    categories: ['']
                }
            });
            setSeries([]);
        }
    }
    
    const [options, setOptions] = useState({
        chart: {
            id: 'apparati-per-anomalia',
            events: {
                mounted: generateData.bind(this)
            },
            toolbar: {
                show: false
            }
        },
        plotOptions: {
            bar: {
                horizontal: true,
                dataLabels: {
                    position: 'bottom'
                }
            }
        },
        xaxis: {
            categories: ['Loading...']
        },
        colors: ['#d62f2f'],
        dataLabels: {
            enabled: true,
            textAnchor: 'start',
            style: {
                colors: ['#363636']
            },
            formatter: function (val, opt) {
                return opt.w.globals.labels[opt.dataPointIndex] + ":  " + val
            },
            offsetX: 0,
            dropShadow: {
                enabled: false
            }
        },
        noData: {
            text: "Nessun dato disponibile",
            align: 'center',
            verticalAlign: 'middle',
            offsetX: 0,
            offsetY: 0,
            style: {
                color: undefined,
                fontSize: '15px',
                fontFamily: undefined
            }
        },
    });
    const [series, setSeries] = useState([{
        name: 'Anomalie',
        data: [1]
    }]);

    

    const showMessage = (message, level) => {
        enqueueSnackbar(message, {
            variant: level,
            anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            },
            autoHideDuration: 3000,
        });
    }

    return (
        <Chart options={options} series={series} type="bar" />
    )
}
export default AnomalieChart;